<template>
    <div class="report-act-button-box" v-if="showReportActBtn && showBtn" @click="clickReportActButton">
        <button class="report-act-button" :class="'button-' + (curReportActPopupType <= 2 ? curReportActPopupType : 3)" :style="'background-image:url('+(curReportActPopupType == 1 && reportActProductGiftData.entry ? reportActProductGiftData.entry : curReportActPopupType == 2 && reportActProductDiffData.entry ? reportActProductDiffData.entry : (curReportActPopupType == 3 || curReportActPopupType == 4) && reportActProductVipYearData.entry ? reportActProductVipYearData.entry : curReportActPopupType == 5 && reportActProductVipFullData.entry ? reportActProductVipFullData.entry : '')+')'"></button>
        <div class="report-act-time">{{reportActCountTime1}}</div>
    </div>
</template>

<script>
import { MIX } from '../../modules/utils';

export default {
    name: 'ReportActBtn',
    computed: {
        showReportActBtn() {
            return this.$store.state.report.showReportActBtn;
        },
        curReportActPopupType() {
            return this.$store.state.report.curReportActPopupType;
        },
        reportActProductGiftData() {
            return this.$store.state.report.reportActProductGiftData;
        },
        reportActProductDiffData() {
            return this.$store.state.report.reportActProductDiffData;
        },
        reportActProductVipYearData() {
            return this.$store.state.report.reportActProductVipYearData;
        },
        reportActProductVipFullData() {
            return this.$store.state.report.reportActProductVipFullData;
        },
        reportActCountTime1() {
            return this.$store.state.report.reportActCountTime1;
        }
    },
    data() {
        return {
            showBtn: true
        }
    },
    mounted() {
        let path = this.$router.history.current.fullPath;
        if(path.indexOf('diagram') != -1 || path.indexOf('strong') != -1) {
            this.showBtn = false
        }
    },
    methods: {
        clickReportActButton() {
            this.$store.state.report.showReportActPopup = true;
            setTimeout(() => {
                if(this.curReportActPopupType == 1) {
                    MIX.trackPageViewed('DifferencePriceOnlyOneChancePage');
                }else if(this.curReportActPopupType == 2) {
                    MIX.trackPageViewed('DifferencePriceLimitedTimePage');
                }else {
                    MIX.trackPageViewed('DifferencePriceUpgradeVipPage');
                }
            }, 20);
        },
    }
}
</script>